import { z } from 'zod';
const ALLOWED_MIME_TYPES = [
    // Images
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/heic',
    'image/heif',
    'image/bmp',
    'image/tiff',
    'image/svg+xml',
    // Videos
    'video/mp4',
    'video/quicktime',
    'video/webm',
    'video/x-msvideo',
    'video/x-matroska',
    // Documents (expense invoices, quotes)
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
    'text/plain',
];
const MAX_FILE_SIZE = 200 * 1024 * 1024; // 200MB (videos can be large)
export const photoTagEntityTypeEnum = z.enum(['EVENT', 'VENUE', 'VENDOR', 'USER']);
export const createPhotoTagSchema = z.object({
    entityType: photoTagEntityTypeEnum,
    entityId: z.string().min(1),
});
export const presignedUrlRequestSchema = z.object({
    fileName: z.string().min(1).max(500),
    mimeType: z.enum(ALLOWED_MIME_TYPES),
});
export const createPhotoSchema = z.object({
    s3Key: z.string().min(1).max(1024),
    fileName: z.string().min(1).max(500),
    mimeType: z.enum(ALLOWED_MIME_TYPES),
    fileSizeBytes: z.number().int().positive().max(MAX_FILE_SIZE),
    caption: z.string().max(2000).optional(),
    latitude: z.number().min(-90).max(90).optional(),
    longitude: z.number().min(-180).max(180).optional(),
    takenAt: z.string().datetime().optional(),
    tags: z.array(createPhotoTagSchema).optional(),
});
export const updatePhotoSchema = z.object({
    caption: z.string().max(2000).nullable().optional(),
    isPublic: z.boolean().optional(),
    showOnLanding: z.boolean().optional(),
});
export const listPhotosQuerySchema = z.object({
    entityType: photoTagEntityTypeEnum.optional(),
    entityId: z.string().min(1).optional(),
    caption: z.string().max(200).optional(),
    page: z.coerce.number().int().positive().optional().default(1),
    limit: z.coerce.number().int().positive().max(100).optional().default(50),
});
export const batchPhotoUrlsSchema = z.object({
    ids: z.array(z.string().uuid()).min(1).max(200),
});
//# sourceMappingURL=photo.js.map